import { Box } from "@mui/material";
import { OperatorType } from "pages/TargetV2/types/targetV2.types";
import React, { FC, useEffect, useRef } from "react";
import dropdown_arrow_blue from "../../../../../../../../src/assets/icons/icon-arrow-down-blue.svg";
import dropdown_arrow_gray from "../../../../../../../../src/assets/icons/icon-arrow-right-gray.svg";
import DropDownSelect from "../dropdownSelect/DropDownSelect";

type SelectOperatorDropDownProps = {
  values: Array<string>;
  index: number;
  handleUpdateOperatorClick: (operator: string, index?: number) => void;
  expandedFilterOfOperator: boolean;
  setExpandedFilterOfOperator: (isExpand: boolean) => void;
  operator?: OperatorType | null;
  disable?: boolean;
};
const SelectOperatorDropDown: FC<SelectOperatorDropDownProps> = ({
  values,
  index,
  handleUpdateOperatorClick,
  expandedFilterOfOperator,
  setExpandedFilterOfOperator,
  operator,
  disable,
}) => {
  const refDropdown = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const checkIfClickedOutside = (e: any) => {
      if (
        refDropdown.current &&
        !refDropdown.current.contains(e.target) &&
        expandedFilterOfOperator
      ) {
        setExpandedFilterOfOperator(false);
      }
    };

    document.addEventListener("mousedown", checkIfClickedOutside);
    return () => {
      document.removeEventListener("mousedown", checkIfClickedOutside);
    };
  }, [setExpandedFilterOfOperator, expandedFilterOfOperator]);

  return (
    <Box
      display="flex"
      flexDirection="column"
      position="relative"
      ref={refDropdown}
      style={{ cursor: disable ? "auto" : "pointer" }}
      onClick={
        disable
          ? undefined
          : () => setExpandedFilterOfOperator(!expandedFilterOfOperator)
      }
    >
      <Box display="flex" gap="6px">
        <Box
          className={` ${disable ? "inactive" : ""} operator-select-wrapper`}
        >
          <Box className="operator-group-select">{operator ?? "And"}</Box>
        </Box>
        <img
          src={disable ? dropdown_arrow_gray : dropdown_arrow_blue}
          alt="Dropdown icon"
          className="arrow-down"
          style={{
            border: disable ? "1px solid #e6e6e6" : "1px solid #2d9de2",
            cursor: disable ? "auto" : "pointer",
            transform: disable
              ? "rotate(90deg)"
              : expandedFilterOfOperator
              ? "rotate(180deg)"
              : "",
          }}
        />
      </Box>

      <DropDownSelect
        values={values}
        isExpandFilter={expandedFilterOfOperator}
        handleClick={handleUpdateOperatorClick}
        index={index}
      />
    </Box>
  );
};

export default SelectOperatorDropDown;
